import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'

@Module({ namespaced: true, name: 'AntecipacaoRecebiveisStore' })
export default class AntecipacaoRecebiveisStore extends VuexModule {
  // AntecipacaoRecebiveis Store
  public antecipacoesList: any[] = []
  public pagina: number = 1
  public qtdPorPagina: number = 50
  public totalRegistros: number = 0
  public filterOn: boolean = false
  public modalAntecipacaoForm: boolean = false
  public antecipacaoById: any = {}
  public profissionalId: string = ''
  public empresaMedicaId: string = ''
  public dadosBancarios: any[] = []
  public dadosBancariosSelecionado: any = {}
  public filtroSituacao: any = null
  public search: any = null
  public antecipacaoId: any = null
  public situacoes: any[] = []
  public bancos: any[] = []
  public tiposPix: any[] = []
  public locaisExecucaoList: any[] = []
  public drawer: boolean = false
  public selectedHospital: any = null
  public proxPagamentoInicio: any = null
  public proxPagamentoFim: any = null

  @Mutation
  setDrawer(value: boolean) {
    this.drawer = value
  }

  @Mutation
  setModalAntecipacaoForm(value: boolean) {
    this.modalAntecipacaoForm = value
  }

  @Mutation
  setAntecipacaoId(id: any) {
    this.antecipacaoId = id
  }

  @Mutation
  setBancos(value: any[]) {
    this.bancos = value
  }

  @Mutation
  setTiposPix(value: any[]) {
    this.tiposPix = value
  }

  @Mutation
  setSelectedHospital(value: any) {
    this.selectedHospital = value
  }

  @Mutation
  setProxPagamentoInicio(value: string) {
    this.proxPagamentoInicio = value
  }

  @Mutation
  setProxPagamentoFim(value: string) {
    this.proxPagamentoFim = value
  }

  @Mutation
  setFilterOn(filterOn: boolean) {
    this.filterOn = filterOn
  }

  @Mutation
  setSituacoes(value: any[]) {
    this.situacoes = value
  }

  @Mutation
  setAntecipacoesList(antecipacoesList: any[]) {
    this.antecipacoesList = antecipacoesList
  }

  @Mutation
  setTotalRegistros(totalRegistros: number) {
    this.totalRegistros = totalRegistros
  }

  @Mutation
  setAntecipacaoById(antecipacao: any) {
    this.antecipacaoById = antecipacao
  }

  @Mutation
  setProfissionalId(profissionalId: any) {
    this.profissionalId = profissionalId
  }

  @Mutation
  setEmpresaMedicaId(empresaMedicaId: any) {
    this.empresaMedicaId = empresaMedicaId
  }

  @Mutation
  setDadosBancarios(value: any[]) {
    this.dadosBancarios = value
  }

  @Mutation
  setDadosBancariosSelecionado(value: any) {
    this.dadosBancariosSelecionado = value
  }

  @Mutation
  setFiltroSituacao(value: any) {
    this.filtroSituacao = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setSearch(value: string) {
    this.search = value
  }

  @Mutation
  setLocaisExecucaoList(value: any[]) {
    this.locaisExecucaoList = value
  }

  @Mutation
  clearFiltroAvançado() {
    this.filtroSituacao = null
    this.selectedHospital = null
    this.proxPagamentoInicio = null
    this.proxPagamentoFim = null
  }
  
  @Action
  async getAllAntecipacoes() {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
        situacao: this.filtroSituacao,
        profissional: this.search,
        hospital: this.selectedHospital ? this.selectedHospital : null,
        proxPagamentoInicio: this.proxPagamentoInicio,
        proxPagamentoFim: this.proxPagamentoFim,
      }

      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.getAllAntecipacoes(params)
      if (request.success) {
        this.context.commit('setAntecipacoesList', request.data.itens || [])
        this.context.commit('setTotalRegistros', request.data.totalRegistros)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getAntecipacaoById() {
    try {
      const params: any = {
        id: this.antecipacaoId,
      }
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.getAntecipacaoById(params)
      if (request.success) {
        this.context.commit('setAntecipacaoById', request.data || {})
        this.context.commit('setEmpresaMedicaId', request.data.empresaMedicaId)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async atualizarAntecipacao() {
    try {
      const paramsAntecipacao: any = {
        id: this.antecipacaoId,
        valorOfertado: this.antecipacaoById.valorOfertado,
        situacao: this.antecipacaoById.novaSituacao,
        proximoPagamento: this.antecipacaoById.proximoPagamento,
      }
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.atualizarAntecipacao(paramsAntecipacao)

      if (request.success) {
        const paramsDadosBancarios: any = {
          id: this.antecipacaoId,
          empresaMedicaId: this.empresaMedicaId,
          ...this.dadosBancariosSelecionado
        }
        const requestBancarios = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.atualizarDadosBancarios(paramsDadosBancarios)
        if (requestBancarios.success) {
          await this.context.dispatch('getAllAntecipacoes')
        }

        return requestBancarios
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getSituacoes() {
    try {
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.getSituacoes()
      if (request.success) {
        this.context.commit('setSituacoes', request.data.status || [])
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getDadosBancarios() {
    try {
      const params: any = {
        id: this.empresaMedicaId,
      }
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.getDadosBancarios(params)
      if (request.success) {
        this.context.commit('setDadosBancarios', request.data.dadosBancarios || {})
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getBancos() {
    try {
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.getBancos()
      if (request.success) {
        this.context.commit('setBancos', request.data || [])
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getTiposPix() {
    try {
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.getTiposPix()
      if (request.success) {
        this.context.commit('setTiposPix', request.data.status || [])
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
  
  @Action
  async getLocaisExecucaoList() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getLocaisExecucaoList()
      if (request.success) {
        this.context.commit('setLocaisExecucaoList', request.data.itens)
        return request
      }
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar os locais de execução.' }
    }
  }

  // AntecipacaoProfissional Store
  showAntecipacao: boolean = false
  showAntecipacaoMock: boolean = false
  antecipacaoProfissional: any = {}
  podeAntecipar: boolean = false
  documentoProfissional: string = ''

  @Mutation
  setDocumentoProfissional(value: string) {
    this.documentoProfissional = value
  }

  @Mutation
  setShowAntecipacao(value: boolean) {
    this.showAntecipacao = value
  }

  @Mutation
  setShowAntecipacaoMock(value: boolean) {
    this.showAntecipacaoMock = value
  }

  @Mutation
  setValorSolicitado(value: number) {
    this.antecipacaoProfissional.valorSolicitado = value
  }

  @Mutation
  setAntecipacaoProfissional(value: boolean) {
    this.antecipacaoProfissional = value
  }

  @Mutation
  setPodeAntecipar(value: boolean) {
    this.podeAntecipar = value
  }

  @Action
  async getAntecipacaoProfissional() {
    try {
      const documento = this.documentoProfissional
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.getAntecipacaoProfissional(documento)
      if (request.success) {
        this.context.commit('setAntecipacaoProfissional', request.data || {})
        if (request.data) {
          this.context.commit('setPodeAntecipar', true)
        } else {
          this.context.commit('setPodeAntecipar', false)
        }
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async submitAntecipacaoProfissional(payload: any) {
    try {
      const antecipacaoId = this.antecipacaoProfissional.id
      payload.antecipacaoId = antecipacaoId
      const request = await Apis.RemuneracaoMedica.AntecipacaoRecebiveisApi.submitAntecipacaoProfissional(payload)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
